import { api } from '../baseApi';
import { makeRequest } from '../makeRequest';
import type { FilterSuggestionsRequest, FilterSuggestionsResponse } from './dto';
import { FilterSuggestionsAPIRoutes } from './route';

export function fetchFilterSuggestions(body: FilterSuggestionsRequest): Promise<FilterSuggestionsResponse> {
  return makeRequest(api.post(FilterSuggestionsAPIRoutes.searchSuggestions(), body));
}
